<template>
	<Card :class="content_class">
		<div>
			<div class="multiple">
				<div class="child-div">时间区间</div>
				<RadioGroup v-model="timePeriod" @on-change="getList">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
						type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>

				</RadioGroup>

			</div>
			<div class="multiple" v-if="userInfo.role_type == 1 || userInfo.role_type == 9">
				<div class="child-div">渠道</div>
				<Select v-model="shop_id" style="width: 200px;" @on-change="getList">
					<Option v-for="item in clientIdList" :value="item.id" :key="item.id">
						{{item.username }}-[{{item.id}}]
					</Option>
				</Select>
				<Button  type="primary" style="margin-left: 10px;" @click="initSearch">重置</Button>
				<div style="padding: 0 25px" v-if="userInfo.role_type == 1 || userInfo.role_type == 9 ">
					<Button class='ivu-btn-circle' @click="addRechargeModal">添加充值</Button>
				</div>
				<Button type="primary" @click="exportData" style="margin-left: 10px;">导出报表</Button>
			</div>
			<div style="width: 100% ;margin-top: 20px;">
				<Table :columns="columns" :data="datas" ref="table">
					<template slot-scope="{ row, index }" slot="status_name">
						<div style="margin: 10px;">
							<span>{{row.status_name}}</span>
						</div>
						<div style="margin-bottom: 10px;" v-if="row.status == 0 &&userInfo.role_type == 1">
							<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
							:data-index="index" @click="editRecharge">去审核</Button>
							<!--Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
								:data-index="index" @click="passRecharge">通过</Button>
							<Button type="error" size="small" :data-id="row.id" @click="refuseRecharge">拒绝</Button-->
						</div>
					</template>
					<template slot-scope="{ row, index }" slot="action">
						<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
							:data-index="index" @click="editRecharge">编辑</Button>
						<Button type="error" size="small" :data-id="row.id" @click="delRecharge" v-if="row.status !=1">删除</Button>
					</template>
				</Table>
			</div>
			<div class="pager">
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small"
					show-elevator />
			</div>
			<!-- 提现申请 -->
			<Modal v-model="modal" width="500" title="添加充值">
				<Form :label-width="120">
					<FormItem label="渠道">
						<Select v-model="rechargeForm.shop_id"  :disabled="rechargeForm.status ==1">
							<Option v-for="item in clientIdList" :value="item.id" :key="item.id">
								{{item.username }}-[{{item.id}}]
							</Option>
						</Select>
					</FormItem>
					<FormItem label="充值日期">
						<DatePicker type="date" :disabled="rechargeForm.status ==1"
							:value="rechargeForm.recharge_date_time" @on-change="rechargeTimeChange"
							placeholder="Select date"></DatePicker>
					</FormItem>
					<FormItem label="到账金额">
						<Input placeholder="到账金额" :disabled="rechargeForm.status ==1"
							v-model="rechargeForm.arrival_amount"></Input>
					</FormItem>
					<FormItem label="备注">
						<Input placeholder="备注" 
							v-model="rechargeForm.remark"></Input>
					</FormItem>
					<FormItem label="添加图片">
						<MyUpload ref="upload"></MyUpload>
					</FormItem>
					<FormItem label="审核状态">
						<span style="padding-right: 20px;" v-if="rechargeForm.status == 0">审核中</span>
						<span style="padding-right: 20px;" v-if="rechargeForm.status == 1">审核通过</span>
						<span style="padding-right: 20px;" v-if="rechargeForm.status == -1">审核拒绝</span>
						<Button type="primary"  style="margin-right: 5px"  @click="passRecharge" v-if="rechargeForm.status == 0 &&userInfo.role_type == 1">通过</Button>
						<Button type="error"  @click="refuseRecharge" v-if="rechargeForm.status == 0 &&userInfo.role_type == 1">拒绝</Button>
					</FormItem>
				</Form>
				<div slot="footer">
					
					<Button type="primary" @click="rechargeSubmit">提交</Button>
					<Button type="default" @click="modal = false">取消</Button>
				</div>
			</Modal>
		</div>
	</Card>
</template>
<script>
	import {
		mapGetters,
		mapActions
	} from "vuex";
	import MyUpload from '../tool/Upload.vue';
	import {
		getRechargeList,
		getClientIdList,
		addRecharge,
		getRecharge,
		delRecharge,
		passRecharge,
		refuseRecharge
	} from "../../api/finance";

	export default {
		name: "RechargeDetail",
		components: {
			MyUpload
		},
		props:['content_class'],
		data() {
			return {
				count: 0,
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 500],
				name: '',
				modal: false,
				timePeriod: '5',
				timePeriodDate: [],
				rechargeForm: {
					recharge_date_time: '',
					arrival_amount: '',
					remark: '',
					status: 0
				},
				clientIdList: [],
				datas: [],
				columns: [
					{
						"title": "渠道名称",
						"key": "username",
						align: 'center'
					},{
						"title": "充值日期",
						"key": "recharge_date_time",
						align: 'center'
					},
					{
						"title": "操作人",
						"key": "username",
						align: 'center'
					},
					{
						"title": "到账金额",
						"key": "arrival_amount",
						align: 'center'
					},
					{
						"title": "状态",
						"slot": "status_name",
						width: 250,
						align: 'center'
					},
					{
						"title": "创建时间",
						"key": "created_at",
						align: 'center'
					},
					{
						"title": "备注",
						"key": "remark",
						align: 'center'
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				columnsCopy: [{
						"title": "充值日期",
						"key": "recharge_date_time",
						align: 'center'
					},
					{
						"title": "操作人",
						"key": "user_name",
						align: 'center'
					},
					{
						"title": "到账金额",
						"key": "arrival_amount",
						align: 'center'
					},
					{
						"title": "渠道名称",
						"key": "username",
						align: 'center'
					},
					{
						"title": "状态",
						"slot": "status_name",
						width: 250,
						align: 'center'
					},
					{
						"title": "创建时间",
						"key": "created_at",
						align: 'center'
					},
					{
						"title": "备注",
						"key": "remark",
						align: 'center'
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				shop_id:'',
				balance: '***',
				consume: '***',
				exportDatas: [],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.userDisplayTable();
			this.loadData();
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			rechargeTimeChange(e) {
				this.rechargeForm.recharge_date_time = e;
				console.log(this.rechargeForm.recharge_date_time)
			},
			initSearch() {
				this.page = 1;
				this.pageSize = 10;
				this.timePeriod = 5;
				this.timePeriodDate = [];
				this.shop_id = '';
				this.getList();
			},
			addRechargeModal() {
				this.rechargeForm = {};
				this.$refs['upload'].uploadList = [];
				this.modal = true;
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getClientIdList(that, data);
				that.clientIdList = res.data.list;
			},
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					timePeriod: that.timePeriod,
					timePeriodDate: that.timePeriodDate,
					shop_id: that.shop_id,
					page: that.page,
					pageSize: that.pageSize
				};
				let res = await getRechargeList(that, data);
				if (res.code == 1) {
					that.datas = res.data.list;
					that.count = res.count;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			async rechargeSubmit() {
				let that = this;
				if(that.rechargeForm.status !=1){
					that.rechargeForm.status = 0;
				}
				let data = {
					token: that.token,
					rechargeForm: that.rechargeForm,
					imgList: that.$refs['upload'].uploadList
				};
				let res = await addRecharge(that, data);
				if (res.code == 1) {
					this.modal = false;
					this.getList();
				}
			},
			userDisplayTable() {
				// type: 4 分公司负责人   5 区长n)
				if (this.userInfo.role_type == 13) { //此处判断不用用户类型是否有有对应的列权限
					this.columns = this.columns.filter(col => col.slot !== 'action')
					this.columns = this.columns.filter(col => col.key !== 'remark')
				} else {
					this.columns = this.columnsCopy
				}
			},
			// 编辑充值
			async editRecharge(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
					imgList: that.$refs['upload'].uploadList
				};
				let res = await getRecharge(that, data);
				if (res.code == 1) {
					var jsonStr = JSON.parse(res.data.item.ext_info); //将视频和图片的json转为数据
					that.$refs['upload'].uploadList = jsonStr.imgList;
					that.rechargeForm = res.data.item;
					that.modal = true;
				}
			},
			// 通过
			passRecharge(e) {
				let that = this;
				let id = that.rechargeForm.id;
				console.log(that.rechargeForm)
				//return;
				that.$Modal.confirm({
					title: '确认审核通过吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id,
								rechargeForm: that.rechargeForm,
								imgList: that.$refs['upload'].uploadList
							}
							let res = await passRecharge(that, data);
							if (res.code == 1) {
								that.modal = false;
								that.$Message.success('操作成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			// 通过
			refuseRecharge(e) {
				let that = this;
				let id = that.rechargeForm.id;
				that.$Modal.confirm({
					title: '确认审核拒绝吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await refuseRecharge(that, data);
							if (res.code == 1) {
								that.$Message.success('操作成功');
								that.modal = false;
								that.getList();
							}
						}, 1000);
					}
				})
			},
			async exportData() {
				let that = this;
				let data = {
					token: that.token,
					timePeriod: that.timePeriod,
					timePeriodDate: that.timePeriodDate,
					page: that.page,
					pageSize: 1000
				};
				let res = await getRechargeList(that, data);
				if (res.code == 1) {
					that.exportDatas = res.data.list;
				}
				var myDate = new Date() 
				this.$refs.table.exportCsv({
					filename: "充值表" + myDate.toLocaleDateString(), //导出Excel的名字
					original: false,
					columns: this.columns, //table的每一列
					// orderid是订单编号，此处进行转换，因为orderid过长，不转换会变成科学计数法的格式
					data: that.exportDatas.map(k => {
						k.orderid = "\t" + k.orderid;
						return k;
					})
				});
			},
			// 删除充值
			delRecharge(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delRecharge(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			recharge() {
				window.open('#/PayInfo')
			}
		},


	}
</script>
<style scoped lang="less">
	.content {

	}
	.content1 {
		height: 650px;
		overflow-y: auto;
		overflow-x: hidden
	}
	.yellow_btn {
		color: #F8BD66;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}


	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}
</style>
